import { UserProfileWidgetCreated } from '../../../User'
import { Container } from '../../Container'

import { PROFILE_CREATED_WIDGET_INHABITANT_VARIANTS } from './ProfileCreatedWidgetInhabitant.constants'

function ProfileCreatedWidgetInhabitant() {
  return PROFILE_CREATED_WIDGET_INHABITANT_VARIANTS.map(
    ({ inhabitantData, isSkeleton = false, label }) => (
      <Container key={label} label={label}>
        <UserProfileWidgetCreated
          isSkeleton={isSkeleton}
          userData={inhabitantData}
        />
      </Container>
    )
  )
}

export default ProfileCreatedWidgetInhabitant
